import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Channel } from '../models/channel';
import { environment } from 'src/environments/environment';
import { AccountService } from './account.service';
import { EnvironmentService } from './environment.service';
import { ChannelResponse } from '../models';

@Injectable({
	providedIn: 'root'
})
export class ChannelsService {

	private historySubject = new BehaviorSubject<any[]>(null);

	userChannelSubject = new BehaviorSubject<any[]>(null);

    private cVersion = 'v16';

	constructor(
		private envService: EnvironmentService,
		private http: HttpClient,
		private accountService: AccountService) {
	}

	getChannels(hero: boolean, showFree: boolean): Observable<ChannelResponse[]> {
		return this.http
			.get<ChannelResponse[]>(this.envService.contentCdnHost + '/channels/' + this.cVersion + '?hero=' + hero + '&showFree=' + showFree + '&isStv=true');
	}

	getLatestVideosChannel(): Observable<ChannelResponse> {
		return this.http
			.get<ChannelResponse>(this.envService.contentCdnHost + '/channels/' + this.cVersion + '/latest?isStv=true');
	}

    getSpecialChannel(type: string): Observable<ChannelResponse> {
        return this.http
            .get<ChannelResponse>(this.envService.contentHost + '/channels/' + this.cVersion + '/special/' + type);
    }

	getChannelById(channelId: number): Observable<ChannelResponse> {
		return this.http
			.get<ChannelResponse>(this.envService.contentCdnHost + '/channels/' + this.cVersion + '/' + channelId + '?isStv=true');
	}

    getChannelBySeasonId(seasonId: number): Observable<ChannelResponse> {
        return this.http
            .get<ChannelResponse>(this.envService.contentCdnHost + '/channels/' + this.cVersion + '/season/' + seasonId + '?isStv=true');
    }

	getChannelsShows(): Observable<ChannelResponse[]> {
		return this.http
			.get<ChannelResponse[]>(this.envService.contentCdnHost + '/channels/' + this.cVersion + '/shows?isStv=true');
	}

	getChannelsShow(channelId: number): Observable<ChannelResponse> {
		return this.http
			.get<ChannelResponse>(this.envService.contentCdnHost + '/channels/' + this.cVersion + '/' + channelId + '?isStv=true');
	}

    getChannelBySlug(slug: string): Observable<ChannelResponse> {
        return this.http
            .get<ChannelResponse>(this.envService.contentCdnHost + '/channels/' + this.cVersion + '/slug/' + slug + '?isStv=true');
    }

	getWatchHistory(): Observable<Channel[]> {
		return this.http
			.get<any[]>(this.envService.userHost + '/v1/watchHistory');
	}

    refreshWatchHistory(): Promise<void> {
        if (this.accountService.isAuthenticated()) {
            return this.accountService.updateToken().then(
                () => {
                    this.getWatchHistory().subscribe(res => {
                        this.historySubject.next(res);
                    });
                },
                () => {
                });
        }
        return Promise.resolve();
    }

	watchHistory(): Observable<any[]> {
		return this.historySubject.asObservable();
	}

	getUserChannels(): Observable<any> {
		return this.http
			.get<any>(this.envService.contentHost + '/v5/userchannels/');
	}

	userChannels(): Observable<any[]> {
		return this.userChannelSubject.asObservable();
	}

	async refreshUserChannels() {
		await this.accountService.updateToken().then(
			() => {
				this.getUserChannels().subscribe(res => {
					this.userChannelSubject.next(res);
				});
			},
			() => {
			});
	}
}
